export const useIsESCDA2025Enabled = () => {
  const isESCDA2025Enabled = true;
  return {
    isESCDA2025Enabled,
    desktopESCDABannerOffset: isESCDA2025Enabled ? { lg: "119px" } : {},
  };
};
